export default __webpack_public_path__ + "febbee3848334a0191598ef3b995f88f.png";